import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../utils/api';

const ContributorCard = () => {
  const [rewardAmount, setRewardAmount] = useState('1');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadRewardAmount();
  }, []);

  const loadRewardAmount = async () => {
    try {
      const response = await api.get('/settings');
      if (response.data.success && response.data.settings) {
        const amount = response.data.settings.article_reward_amount || '1';
        setRewardAmount(amount);
      }
    } catch (error) {
      console.error('Erreur chargement reward amount:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return null;

  return (
    <div className="relative bg-surface rounded-2xl p-8 border border-yellow-400/15 overflow-hidden">
      {/* Subtle ambient glow */}
      <div className="absolute -top-20 -right-20 w-60 h-60 bg-yellow-400/[0.06] rounded-full blur-3xl pointer-events-none"></div>

      <div className="relative z-10 flex flex-col md:flex-row items-start gap-6">
        {/* Icon */}
        <div className="flex-shrink-0 w-12 h-12 bg-yellow-400/10 rounded-xl flex items-center justify-center border border-yellow-400/20">
          <i className="fas fa-pen-fancy text-xl text-yellow-400"></i>
        </div>

        {/* Content */}
        <div className="flex-1">
          <div className="flex flex-wrap items-center gap-3 mb-2">
            <h3 className="text-xl font-bold text-white">Deviens contributeur</h3>
            <span className="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-semibold bg-green-500/15 text-green-400 border border-green-500/20">
              <i className="fas fa-coins mr-1"></i>
              +{rewardAmount}€ / article
            </span>
          </div>
          <p className="text-gray-400 text-sm mb-4 leading-relaxed">
            Rédige des articles sur l'hébergement gaming et gagne <span className="font-semibold text-yellow-400">{rewardAmount}€ en crédit boutique</span> pour chaque article publié.
          </p>
          <div className="flex flex-wrap gap-4 text-xs text-gray-500">
            <span className="flex items-center gap-1.5">
              <i className="fas fa-check text-green-400/70 text-[10px]"></i>
              Paiement instantané
            </span>
            <span className="flex items-center gap-1.5">
              <i className="fas fa-check text-green-400/70 text-[10px]"></i>
              Sans limite
            </span>
            <span className="flex items-center gap-1.5">
              <i className="fas fa-check text-green-400/70 text-[10px]"></i>
              Crédit multi-services
            </span>
          </div>
        </div>

        {/* CTA */}
        <div className="flex-shrink-0 mt-2 md:mt-0">
          <Link
            to="/contributor/login"
            className="inline-flex items-center gap-2 bg-yellow-400 text-gray-900 font-semibold px-5 py-2.5 rounded-lg text-sm hover:brightness-110 transition-all"
          >
            <i className="fas fa-arrow-right text-xs"></i>
            Commencer à écrire
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ContributorCard;
